import { Language } from 'config/constants/languages'
import { RowCenter } from 'layout/Components/Row'
import { getIcon } from 'svgs'
import { FlexProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { StyledLanguageItem } from '../style'

interface LanguageItemProps extends FlexProps {
  item: Language
  handleSelect: (code: string) => void
}

const LanguageItem: React.FC<LanguageItemProps> = ({ item, handleSelect, ...props }) => {
  const Logo = getIcon(item.logo)
  return (
    <StyledLanguageItem
      id={`language-select-item-${item.code}`}
      onClick={() => {
        handleSelect(item.code)
      }}
      {...props}
    >
      <RowCenter width="24px" height="24px">
        <Logo style={{ borderRadius: '50%' }} />
      </RowCenter>
      <Text bold ml="12px" color="textSubtle" fontSize="14px">
        {item.name}
      </Text>
    </StyledLanguageItem>
  )
}

export default LanguageItem
